import { render, staticRenderFns } from "./BatchNumberPage.vue?vue&type=template&id=bce33c82&"
import script from "./BatchNumberPage.vue?vue&type=script&lang=js&"
export * from "./BatchNumberPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports